import { AxiosHelper } from "../axiosConfig";
import { IQuestion, IQuestionSearch } from "../model/interface/question";
import APIConstant from "../utils/apiConstant";
import { IQuestionImageFilter } from "../model/interface/questionImageFilter";
import { ISearchAuthoredQuestionRequest } from "../model/interface/searchAuthoredQuestionRequest";
import { IUnassociateQuestionStandards } from "../model/interface/unAssosiateQuestion";
import { ActionResponse } from "../model/interface/actionResponse";
import {
  getJoinedStringByArray,
  getJoinedStringByItem,
} from "../utils/reusedFunctions";

export const getQuestionTypes = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_TYPE, {});
};

export const getPayload = (code) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PAYLOAD_SCHEMA, {
    params: {
      code: code,
    },
  });
};

export const addQuestion = (question: IQuestion) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_QUESTION,
    question,
    {}
  );
};

export const saveQuestion = (question: IQuestion) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_QUESTION_SAVE,
    question,
    {}
  );
};

export const getQuestion = (id) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_QUESTION}/${id}`,
    {}
  );
};

export const getQuestionByQuestionGuid = (questionGuid: string) => {
  return AxiosHelper.axiosInstance().get<IQuestion>(
    `${APIConstant.CMS_QUESTION_BY_QUESTION_GUID}/${questionGuid}`,
    {}
  );
};

export const getAllQuestions = (questionData: IQuestionSearch) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    params: {
      questionTypeIds: getJoinedStringByArray(questionData.questionTypeIds),
      stateId: questionData.stateId,
      gradeLevel: questionData.gradeLevel,
      subjectId: questionData.subjectId,
      domainId: questionData.domainId,
      standardId: questionData.standardId,
      dok: questionData.dok,
      tagId: questionData.tagId,
      isPublished: questionData.isPublished,
      isDiagnostics: questionData.isDiagnostics,
      isActive: questionData.isActive,
      translation: questionData.translation,
      explanation: questionData.explanation,
      questionIds: questionData.questionId?.toString(),
      orderbyColumn: questionData.orderbyColumn,
      sortDir: questionData.sortDir,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
      externalSourceId: questionData.externalSourceId,
      externalSourceTypeId: questionData.externalSourceTypeId,
      questionClassificationId: questionData.questionClassificationId,
      questionText: questionData.questionText,
      tagIds: questionData.tagIds,
      tagType: questionData.tagType,
      showLinkedStandardQuestions: questionData.showLinkedStandardQuestions,
      contentAreaId: questionData.contentAreaId,
      createdByUserId: questionData.createdByUserId,
      feedbackSearch: questionData.feedbackSearch,
      dateCreatedMin: questionData.dateCreatedMin,
      dateCreatedMax: questionData.dateCreatedMax,
      jsonDefinition: questionData.jsonDefinition,
    },
  });
};
export const getQuestionExport = (questionData: IQuestionSearch) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_EXPORT, {
    params: {
      questionTypeIds: getJoinedStringByArray(questionData.questionTypeIds),
      stateId: questionData.stateId,
      gradeLevel: questionData.gradeLevel,
      subjectId: questionData.subjectId,
      domainId: questionData.domainId,
      standardId: questionData.standardId,
      dok: questionData.dok,
      tagId: questionData.tagId,
      isPublished: questionData.isPublished,
      isDiagnostics: questionData.isDiagnostics,
      isActive: questionData.isActive,
      translation: questionData.translation,
      explanation: questionData.explanation,
      questionIds: questionData.questionId?.toString(),
      orderbyColumn: questionData.orderbyColumn,
      sortDir: questionData.sortDir,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
      externalSourceId: questionData.externalSourceId,
      externalSourceTypeId: questionData.externalSourceTypeId,
      questionClassificationId: questionData.questionClassificationId,
      questionText: questionData.questionText,
      tagIds: questionData.tagIds,
      tagType: questionData.tagType,
      showLinkedStandardQuestions: questionData.showLinkedStandardQuestions,
      contentAreaId: questionData.contentAreaId,
      createdByUserId: questionData.createdByUserId,
      feedbackSearch: questionData.feedbackSearch,
      dateCreatedMin: questionData.dateCreatedMin,
      dateCreatedMax: questionData.dateCreatedMax,
      jsonDefinition: questionData.jsonDefinition,
    },
  });
};

export const getAllQuestionByIds = (questionData: IQuestion) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    params: {
      standardId: questionData.standardId,
      isPublished: questionData.isPublished,
      isDiagnostics: questionData.isDiagnostics,
      isActive: questionData.isActive,
      questionClassification: questionData.questionClassificationId,
      questionIds: questionData.questionIds,
      orderbyColumn: questionData.orderbyColumn,
      sortDir: questionData.sortDir,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
    },
  });
};

export const updateQuestion = (question: IQuestion) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_QUESTION,
    question,
    {}
  );
};

export const deleteQuestion = (id, userId) => {
  return AxiosHelper.axiosInstance().delete(
    `${APIConstant.CMS_QUESTION_DELETE}/${id}`,
    {
      params: { userId: userId },
    }
  );
};

export const getQuestionImages = (questionImageData: IQuestionImageFilter) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTIONIMAGE, {
    params: {
      questionTypeId: questionImageData.questionTypeId,
      stateId: questionImageData.stateId,
      subjectId: questionImageData.subjectId,
      domainId: questionImageData.domainId,
      standardId: questionImageData.standardId,
      dok: questionImageData.dok,
      usatpId: questionImageData.usatpId,
      author: questionImageData.author,
      isActive: questionImageData.isActive,
      isPublished: questionImageData.isPublished,
      pageSize: questionImageData.pageSize,
      pageNumber: questionImageData.pageNumber,
    },
  });
};

export const getPassgeQuestions = (questionData) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    params: {
      SubjectId: questionData.subjectId,
      GradeId: questionData.gradeId,
      DomainId: questionData.domainId,
      StandardId: questionData.standardId,
      QuestionIds: questionData.questionIds,
      QuestionTypeIds: getJoinedStringByItem(questionData.questionTypeId),
      orderbyColumn: "questionId",
      sortDir: questionData.sortByDesc,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
      IsPublished: questionData.isPublished,
      IsDiagnostics: questionData.isDiagnostics,
      isVideoLesson: questionData.isVideoLesson,
      isConstructedResponse: questionData.isConstructedResponse,
      IsActive: questionData.isActive,
      DestinationPassageId: questionData.destinationPassageId
        ? questionData.destinationPassageId
        : 0,
      createdByUserId: questionData.createdByUserId,
      QuestionText: questionData.questionText,
    },
  });
};

export const deleteAssociatedQuestions = (params) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_ASSOCIATE_QUESTIONS_DELETE,
    {
      params,
    }
  );
};
export const UnAssociateQuestions = (
  questionStandards: Array<IUnassociateQuestionStandards>
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_MULTIASSOCIATE_QUESTIONS_DELETE,
    { data: { questionStandards } }
  );
};
export const deleteAssociatedStandards = (params) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_ASSOCIATE_STANDARDS_DELETE,
    {
      params,
    }
  );
};
export const associateQuestionStandards = (
  questionId: number,
  standardIds: number[]
) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_ASSOCIATE_QUESTION_STANDARDS,
    {
      questionId: questionId,
      standardIds: standardIds,
    }
  );
};
export const getAssociatedQuestions = (params) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_GET_ASSOCIATED_QUESTIONS,
    {
      params,
    }
  );
};

export const getClassifications = () => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_QUESTION_CLASSIFICATION}`
  );
};

export const postQuestionTag = (Tag) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_QUESTIONTAG, Tag, {});
};

export const deleteQuestionTag = (tag) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_QUESTIONTAG, {
    params: tag,
  });
};

export const getAllAuthoredQuestions = (
  questionData: ISearchAuthoredQuestionRequest
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.APP_TEACHERQUESTION, {
    params: {
      questionTypeIds: questionData.questionTypeIds,
      stateId: questionData.stateId,
      subjectId: questionData.subjectId,
      domainIds: questionData.domainIds,
      standardIds: questionData.standardIds,
      isPublished: questionData.isPublished,
      isActive: questionData.isActive,
      questionIds: questionData.teacherQuestionId,
      orderbyColumn: questionData.orderbyColumn,
      sortByDesc: questionData.sortByDesc,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
      dok: questionData.dok,
      createdByUserId: questionData.createdByUserId,
    },
  });
};

export const getQuestionTypesForTeacher = () => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.APP_QUESTIONTYPES_FOR_TEACHER,
    {
      params: {},
    }
  );
};

export const validateExternalSourceId = (
  externalsourceId,
  externalSourceTypeId,
  questionId
) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_QUESTION_VALIDATE_EXTERNALSOURCEID,
    {
      params: {
        externalsourceId: externalsourceId,
        externalSourceTypeId: externalSourceTypeId,
        questionId: questionId,
      },
    }
  );
};

export const getQuestionSettings = (questionId: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTIONSETTINGS, {
    params: {
      questionId: questionId,
    },
  });
};

export const uploadAsset = (formData: FormData) => {
  return AxiosHelper.axiosInstance().post<ActionResponse>(
    APIConstant.CMS_QUESTION_ASSET_UPLOAD,
    formData,
    {}
  );
};

export const getQuestionPayloadByItemReference = (itemReferences: string[]) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_GET_QUESTION_PAYLOAD_BY_ITEMREFRENCES,
    {
      itemReferences: itemReferences,
    }
  );
};

export const getQuestionGuid = (questionId: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_QUESTION_QUESTION_GUID.replace(
      ":id",
      questionId.toString()
    ),
    {}
  );
};
